/*!
 *
 *  interview.ts
 *
 */
import { createApp } from 'vue';
function sortQuestion(array, target) {
    var index = array.indexOf(target);
    if (index > -1) {
        var movedElement = array.splice(index, 1)[0];
        array.unshift(movedElement);
    }
    return array;
}
function splitArrayIntoGroups(array, numGroups) {
    var groups = [];
    var remainder = array.length % numGroups;
    var startIndex = 0;
    for (var i = 0; i < numGroups; i++) {
        var groupSize = Math.floor(array.length / numGroups);
        if (i < remainder) {
            groupSize++;
        }
        var group = array.slice(startIndex, startIndex + groupSize);
        groups.push(group);
        startIndex += groupSize;
    }
    return groups;
}
export default function () {
    var q = questions.q;
    var urlParams = new URLSearchParams(window.location.search);
    var question_id = urlParams.get('question_id');
    if (question_id) {
        var mainQuestion = q.find(function (val) { return val.question_id === Number(question_id); });
        q = sortQuestion(q, mainQuestion);
    }
    ;
    var questionGroup = splitArrayIntoGroups(q, 3);
    var items = [];
    questionGroup.forEach(function (val, i) {
        val.forEach(function (val2) {
            var _q = Object.assign({}, val2, {
                type: 'question'
            });
            items.push(_q);
        });
        if (questions.img[i]) {
            var _img = Object.assign({}, questions.img[i], {
                type: 'image'
            });
            items.push(_img);
        }
        ;
    });
    console.log(items);
    var app = createApp({
        data: function () {
            return {
                items: items
            };
        },
        mounted: function () {
        }
    });
    app.mount('#interviewBody');
}
